module.exports = __webpack_public_path__ + "static/media/menu-elepsis.67426c28.svg";